import type { ColumnDef } from "@tanstack/react-table";

import { renderEmptyCellState } from "@/components/Table/utils";

import type { CareerPlanActionItem } from "./careerPlanDocument";

export type ActionPlanRow = CareerPlanActionItem & { id: string };

function ActionPlanTextCell({ getValue }: { getValue: () => unknown }) {
  const value = getValue();
  if (typeof value !== "string" || value.trim() === "") {
    return renderEmptyCellState("");
  }

  return <span className="whitespace-pre-wrap break-words">{value}</span>;
}

export function getActionPlanColumns(): ColumnDef<ActionPlanRow, unknown>[] {
  return [
    {
      accessorKey: "focusArea",
      header: "Area of Focus",
      enableSorting: false,
      cell: ActionPlanTextCell
    },
    {
      accessorKey: "recommendedActivity",
      header: "Recommended Activity",
      enableSorting: false,
      cell: ActionPlanTextCell
    },
    {
      accessorKey: "successMeasure",
      header: "Success Measure",
      enableSorting: false,
      cell: ActionPlanTextCell
    },
    {
      accessorKey: "timeframe",
      header: "Timeframe",
      enableSorting: false,
      cell: ActionPlanTextCell
    }
  ];
}
